import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=0b20a309&"
import script from "./ActivityList.vue?vue&type=script&lang=js&"
export * from "./ActivityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports